import viewDemoDialog from './viewDemoDialog.container'

export default viewDemoDialog